import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_SUPPORT_TICKETS, APP_FILE_SUPPORT_TICKETS_LIST } from "./supportTickets.constants";

const SupportTicketsList = Loadable(
  lazy(() =>
    import("./SupportTicketsList").then(
      ({ SupportTicketsList }) => ({
        default: SupportTicketsList,
      })
    )
  )
);
const SupportTickets = Loadable(
  lazy(() =>
    import("./SupportTickets").then(
      ({ SupportTickets }) => ({
        default: SupportTickets,
      })
    )
  )
);
export const supportTicketsRoutes = [
  {
        path: `${APP_FILE_SUPPORT_TICKETS_LIST}`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <SupportTicketsList />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_SUPPORT_TICKETS}`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <SupportTickets />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_SUPPORT_TICKETS}/:supportTicketsCode`,
        exact: true,
        element: (
          <AuthorizedRoute allowFullAccess moduleKeys={[]}>
            <SupportTickets />
          </AuthorizedRoute>
        ),
      },
];
